import Ajax from '../../../../common/js/Ajax.js';
import Form from '../../../../common/js/form/Form.js';
import Widget from '../../../../common/js/Widget.js';

export default class RegisterWidget extends Widget {

	constructor($widget) {
		super($widget);

		Form.onSubmit(this.$widget, action => {
			

			var $password1 = action.findField('password');
			var $password2 = action.findField('password2');
			if ($password1.val() !== $password2.val()) {
				Form.showFieldError({
					$field: $password2,
					short: 'Passwords do not match.',
					long: 'The passwords do not match.'
				});
				action.error();
				return;
			}

			Ajax.rpc('/register', {
				email: action.findField('email').val(),
				password: $password1.val(),
				remember: action.findField('remember').is(':checked') ? true : false
			}, result => {
				if (result === 'OK') {
					window.location.href = '/';
				} else if (result === 'DUPLICATE_EMAIL') {
					action.error('Registration failed, a user with this email address already exists.');
				} else {
					action.error('Registration failed');
				}
			}, error => {
				action.error('Registration failed', error);
			});
		});
	}

}
